import { makeStyles } from "tss-react/mui";

export const useCardManagerStyles = makeStyles<void, "cardMouseOut">()(
    (theme, p, classes) => ({
        cardMouseOut: {
            visibility: "hidden",
        },
        cardMouseOver: {
            visibility: "visible",
            [`& .${classes.cardMouseOut}`]: {
                visibility: "visible",
            }
        },
    })
);
